const en = {
  'app.loading': 'Loading your dashboard...',
  'app.title': 'Gharamiat',
  'brand.name': 'Gharamiat',
  'brand.mascot.her':
    'Illustration of her: a doodle woman with her hand on her hip',
  'brand.mascot.him':
    'Illustration of him: a doodle man flexing with a cheeky grin',
  'brand.mascot.pair':
    'Illustration of the couple: a doodle woman and man facing each other with a heart between them',

  'nav.home': 'Home',
  'nav.dashboard': 'Dashboard',
  'nav.game': 'Game',
  'nav.settings': 'Settings',
  'nav.history': 'History',
  'nav.rewards': 'Rewards',
  'nav.fantasy': 'Fantasy',
  'nav.admin': 'Admin',
  'nav.logout': 'Logout',
  'nav.backToDashboard': 'Back to Dashboard',
  'nav.welcomeUser': 'Welcome, {{name}}!',

  'common.back': 'Back',
  'common.continue': 'Continue',
  'common.cancel': 'Cancel',
  'common.save': 'Save Changes',
  'common.saving': 'Saving...',
  'common.saveSuccess': 'Settings saved successfully!',
  'common.saveError': 'Failed to save settings. Please try again.',
  'common.optional': '(optional)',
  'common.all': 'All',
  'common.you': 'You',
  'common.partner': 'Partner',
  'common.random': 'Random',
  'common.custom': 'Custom',
  'common.retry': 'Retry',
  'common.exit': 'Exit',
  'common.cards': '{{count}} card|{{count}} cards',
  'common.level': 'Level {{level}}',

  'settings.title': 'Settings',
  'settings.subtitle': 'Customize your experience and manage your account',
  'settings.profile': 'Profile',
  'settings.gameSettings': 'Game Settings',
  'settings.profileTitle': 'Profile Information',
  'settings.profileSubtitle': 'Your account details and preferences',
  'settings.name': 'Name',
  'settings.email': 'Email',
  'settings.role': 'Role',
  'settings.notAvailable': 'Not available',
  'settings.language': 'Language',
  'settings.difficulty': 'Difficulty Level',
  'settings.contentPreferences': 'Content Preferences',
  'settings.showExplicit': 'Show explicit content',
  'settings.egyptianSlang': 'Egyptian slang cards',
  'settings.egyptianSlangDesc':
    'Bold cards written in Egyptian colloquial Arabic. Off keeps them out of every game.',
  'settings.notifications': 'Enable notifications',
  'settings.sound': 'Enable sound effects',
  'settings.showPromptImages': 'Show prompt and position images',
  'settings.showPromptImagesDesc':
    'When off, challenge text still loads but illustration images are hidden.',

  'gameSettings.title': 'Game Settings',
  'gameSettings.subtitle': 'Customize your gaming experience and preferences',
  'gameSettings.general': 'General',
  'gameSettings.gameplay': 'Gameplay',
  'gameSettings.appearance': 'Appearance',
  'gameSettings.notifications': 'Notifications',
  'gameSettings.generalTitle': 'General Settings',
  'gameSettings.generalSubtitle': 'Basic configuration for your account',
  'gameSettings.autoSave': 'Auto-save progress',
  'gameSettings.autoSaveDesc':
    'Automatically save your game progress and settings',
  'gameSettings.gameplayTitle': 'Gameplay Settings',
  'gameSettings.gameplaySubtitle': 'Customize your gaming experience',
  'gameSettings.appearanceTitle': 'Appearance Settings',
  'gameSettings.appearanceSubtitle': 'Customize the look and feel of the game',
  'gameSettings.notificationsTitle': 'Notifications & Sound',
  'gameSettings.notificationsSubtitle': 'Manage your notification preferences',
  'gameSettings.saveSectionTitle': 'Save Changes',
  'gameSettings.saveSectionDesc': 'Your settings will be applied immediately',

  'difficulty.easy.label': 'Easy',
  'difficulty.easy.desc': 'Simple challenges for beginners',
  'difficulty.medium.label': 'Medium',
  'difficulty.medium.desc': 'Balanced challenges for most couples',
  'difficulty.hard.label': 'Hard',
  'difficulty.hard.desc': 'Advanced challenges for experienced couples',

  'setup.step.players': 'Players',
  'setup.step.category': 'Category',
  'setup.step.spice': 'Spice',
  'setup.stepOf': 'Step {{current}} of {{total}}',
  'setup.backToDashboard': 'Back to Dashboard',
  'setup.exitSetup': 'Exit game setup',
  'setup.coupleTitle': 'Set up your couple',
  'setup.coupleSubtitle':
    "Choose your dynamic and your names — prompts match each person's role.",
  'setup.coupleDynamic': 'Couple dynamic',
  'setup.sameDevice': 'Same device',
  'setup.player1Label': 'Player 1 · You · {{gender}}',
  'setup.player2Label': 'Player 2 · Partner · {{gender}}',
  'setup.yourName': 'Your name',
  'setup.partnerName': "Partner's name",
  'setup.twoPhones.hint':
    'Want to play on two phones? Quick setup has Apart and "Two phones, same room".',
  'setup.twoPhones.quick': 'Open quick setup',
  'setup.twoPhones.partner': 'Go to Partner',
  'setup.pickVibe': 'Pick a vibe',
  'setup.pickVibeSubtitle': 'Optional — tap Surprise me for a random mix.',
  'setup.surpriseMe': 'Surprise me',
  'setup.narrowDown': 'Narrow it down',
  'setup.narrowDownHint':
    'Tap a subcategory to focus the deck, or leave All for the full category mix.',
  'setup.loadingSubcategories': 'Loading subcategories…',
  'setup.fantasyExplorerTruthHint':
    'For the fantasy catalog wizard (themes like threesome configurations), tap the Fantasy Exploration subcategory below — not Truth alone.',
  'setup.fantasyExplorerLeafHint':
    'Opens the Fantasy Exploration wizard: browse catalog themes by section, pick your top 3, then refine (e.g. threesome types).',
  'setup.availabilityNoCards': 'No cards',
  'setup.availabilityLimited':
    'Limited · {{count}} card|Limited · {{count}} cards',
  'setup.howHot': 'How hot tonight?',
  'setup.spiceSubtitle':
    'Only levels with cards in your chosen category are selectable.',
  'setup.noCardsWarning':
    'No cards match this category with your current player setup. Pick another category or adjust couple dynamic on step 1.',
  'setup.readyToPlay': 'Ready to play',
  'setup.summaryPlayStyle': 'Play style',
  'setup.summaryPlayers': 'Players',
  'setup.summaryCategory': 'Category',
  'setup.summarySpice': 'Spice',
  'setup.starting': 'Starting…',
  'setup.startGame': 'Start game',

  'couple.maleFemale.label': 'Man & Woman',
  'couple.maleFemale.desc': 'You play as the man, partner as the woman',
  'couple.femaleMale.label': 'Woman & Man',
  'couple.femaleMale.desc': 'You play as the woman, partner as the man',
  'couple.femaleFemale.label': 'Woman & Woman',
  'couple.femaleFemale.desc': 'Shared prompts until a dedicated deck ships',
  'couple.gender.man': 'Man',
  'couple.gender.woman': 'Woman',

  'spice.mild.label': 'Mild',
  'spice.mild.tagline': 'Soft flirts & gentle teasing',
  'spice.warm.label': 'Warm',
  'spice.warm.tagline': 'Cozy chemistry building',
  'spice.hot.label': 'Hot',
  'spice.hot.tagline': 'Playful tension rises',
  'spice.spicy.label': 'Spicy',
  'spice.spicy.tagline': 'Bold dares & blushing',
  'spice.explicit.label': 'Explicit',
  'spice.explicit.tagline': 'No filter, all spark',
  'spice.intense.label': 'Intense',
  'spice.intense.tagline': 'Heart-racing moments',
  'spice.wild.label': 'Wild',
  'spice.wild.tagline': 'Adventurous & uninhibited',
  'spice.fierce.label': 'Fierce',
  'spice.fierce.tagline': 'Passion turned up loud',
  'spice.extreme.label': 'Extreme',
  'spice.extreme.tagline': 'For the brave together',
  'spice.maximum.label': 'Maximum',
  'spice.maximum.tagline': 'Every limit explored',
  'spice.preset.sweet': 'Sweet & slow',
  'spice.preset.steamy': 'Steamy night',
  'spice.preset.wildRide': 'Wild ride',
  'spice.preset.range': '{{min}}–{{max}}',
  'spice.heat.soft': 'Soft',
  'spice.heat.scorching': 'Scorching',
  'spice.unavailable': 'unavailable',
  'spice.loadingAvailability':
    'Checking which heat levels are available for this category…',
  'spice.levelRange': 'Levels {{min}}–{{max}}',
  'spice.cardsAtLevel':
    '{{count}} card at this level|{{count}} cards at this level',
  'spice.cardsInRange':
    '{{count}} card across levels {{min}}–{{max}}|{{count}} cards across levels {{min}}–{{max}}',
  'spice.cardsInCategory':
    '{{count}} card in this category|{{count}} cards in this category',
  'spice.perLevel': '{{count}} per level',
  'spice.surpriseTitle': 'Surprise us',
  'spice.surpriseDesc': 'Pick a heat level below, or skip for a random mix',
  'spice.pickerLabel': 'Spice level',

  'game.scoreboard': 'Scoreboard',
  'game.round': 'Round {{round}}',
  'game.yourTurn': 'Your turn',
  'game.playerTurn': "{{name}}'s turn",
  'game.player1Turn': "Player 1's turn",
  'game.player2Turn': "Player 2's turn",
  'game.endGame': 'End Game',
  'game.quickExit': 'Quick exit',
  'game.fantasyExplorer': 'Fantasy Exploration',
  'fantasyExplorer.selectedCount': 'Selected {{selected}} / {{total}}',
  'game.noMorePrompts': 'No more prompts available',
  'game.somethingWrong': 'Something went wrong',
  'game.deckRepeat': "You've seen every card in this deck — here's a repeat.",
  'game.spiceMismatch':
    'Session mood is level {{sessionLevel}}, but this card is level {{cardLevel}}{{suffix}}.',
  'game.spiceMismatchSuffix': ' (nearest available match)',
  'game.undoFailed': 'Could not undo. Please try again.',
  'game.undoNothing': 'Nothing to undo.',
  'game.finalResults': 'Final Results',
  'game.skip': 'Skip',
  'game.complete': 'Complete',
  'game.saving': 'Saving…',
  'game.savedNext': 'Saved — loading next challenge…',
  'game.answer.group': 'Answer cards',
  'game.answer.outLoud': 'Answer out loud',
  'game.answer.chose': '{{name}} chose',
  'game.answer.choosing': '{{name}} is choosing...',
  'game.answer.error.invalid':
    'That answer is not on this card. We refreshed the game.',

  'history.title': 'Game History',
  'history.subtitle': 'Track your progress and view completed challenges',
  'history.totalGames': 'Total Games',
  'history.completedGames': 'Completed Games',
  'history.completedCards': 'Completed Cards',
  'history.totalCards': 'Total Cards',
  'history.cardsPlayed': 'Cards Played',
  'history.avgScore': 'Avg Score',
  'history.avgTime': 'Avg Time',
  'history.searchPlaceholder': 'Search challenges...',
  'history.filters': 'Filters',
  'history.sortBy': 'Sort by:',
  'history.sort.date': 'Date',
  'history.sort.score': 'Score',
  'history.sort.time': 'Time',
  'history.filter.category': 'Category',
  'history.filter.allCategories': 'All Categories',
  'history.filter.spiceLevel': 'Spice Level',
  'history.filter.allLevels': 'All Levels',
  'history.spiceHearts': '{{level}} hearts',
  'history.loading': 'Loading your game history...',
  'history.emptyTitle': 'No Games Found',
  'history.emptyFiltered': 'Try adjusting your filters or search terms.',
  'history.emptyDefault': 'Start playing to build up your game history!',
  'history.startFirstGame': 'Start Your First Game',
  'history.challengeCompleted': 'Challenge completed',
  'history.score': 'Score',
  'history.time': 'Time',
  'history.progress': 'Progress',
  'history.progressPercent': '{{percent}}%',

  'rewards.title': 'Rewards',
  'rewards.subtitle': 'Your streaks, stats and achievements',
  'rewards.loading': 'Loading your rewards...',
  'rewards.dayStreak': 'Day Streak',
  'rewards.streakProgress': '{{count}} of {{goal}} days',
  'rewards.cardsPlayed': 'Cards played',
  'rewards.cardsCompleted': 'Cards completed',
  'rewards.totalScore': 'Total score',
  'rewards.achievements': 'Achievements',
  'rewards.day.mon': 'M',
  'rewards.day.tue': 'T',
  'rewards.day.wed': 'W',
  'rewards.day.thu': 'T',
  'rewards.day.fri': 'F',
  'rewards.day.sat': 'S',
  'rewards.day.sun': 'S',
  'rewards.badge.streak7.title': '7-Day Streak',
  'rewards.badge.streak7.desc': 'Play 7 days in a row',
  'rewards.badge.truthSeeker.title': 'Truth Seeker',
  'rewards.badge.truthSeeker.desc': 'Complete 20 truth prompts',
  'rewards.badge.dareDevil.title': 'Dare Devil',
  'rewards.badge.dareDevil.desc': 'Complete 10 dares',
  'rewards.badge.fantasist.title': 'Fantasist',
  'rewards.badge.fantasist.desc': 'Complete 15 fantasy cards',
  'rewards.badge.spiceMaster.title': 'Spice Master',
  'rewards.badge.spiceMaster.desc': 'Play at level 9+ five times',
  'rewards.badge.soulmates.title': 'Soulmates',
  'rewards.badge.soulmates.desc': 'Play together on 30 days',
  'rewards.badge.luckyScratch.title': 'Lucky Scratch',
  'rewards.badge.luckyScratch.desc': 'Reveal 5 scratch cards',
  'rewards.badge.legend.title': 'Legend',
  'rewards.badge.legend.desc': 'Reach 100 cards played',

  'onboarding.welcomeTo': 'Welcome to',
  'onboarding.welcomeBody':
    'Truth, dare, fantasy and more — designed for the two of you.',
  'onboarding.continue': 'Continue',
  'onboarding.startPlaying': 'Start playing',
  'onboarding.skip': 'Skip',
  'dashboard.greeting.morning': 'Good morning',
  'dashboard.greeting.afternoon': 'Good afternoon',
  'dashboard.greeting.evening': 'Good evening',
  'dashboard.greeting.night': 'Hello',
  'dashboard.greeting.withName': '{{greeting}}, {{name}}',
  'dashboard.streak.days': '{{count}}-day streak',
  'dashboard.streak.none': 'Start a streak',
  'dashboard.partner.playingWith': 'With {{name}}',
  'dashboard.partner.add': 'Add your partner',
  'dashboard.resume.label': 'Game in progress',
  'dashboard.resume.paused': 'Paused',
  'dashboard.resume.round': 'Round {{round}}',
  'dashboard.resume.button': 'Resume',
  'dashboard.playAgain.label': 'Last game',
  'dashboard.playAgain.button': 'Play again',
  'dashboard.starting': 'Starting…',
  'dashboard.error.start': "Couldn't start the game. Please try again.",
  'dashboard.customGame': 'Custom game',
  'dashboard.error.partnerSession':
    'Your partner already started a game. Join it instead.',
  'dashboard.joinInstead':
    "Join {{name}}'s game, or end it from inside the game to start a new one.",
  'dashboard.mixTitle': 'Random mix',
  'dashboard.moods.title': 'Pick a mood',
  'dashboard.moods.subtitle': 'One tap and you are playing',
  'mood.reason.explicit': 'Turn on explicit cards in Settings to play this',
  'mood.reason.empty': 'No cards match this mood right now',
  'mood.reason.remote': 'Pair with your partner to play this',
  'mood.reason.fewExplicit':
    'Not enough cards. Turn on explicit cards or change your settings',
  'mood.reason.few': 'Not enough cards for your settings',
  'mood.error.notPlayable':
    'This mood does not have enough cards for your settings. Turn on explicit cards or change your settings, then try again.',
  'quickSetup.title': 'Quick setup',
  'quickSetup.subtitle':
    'Everything is prefilled. Change what you like, then start.',
  'quickSetup.players': 'Players',
  'quickSetup.dynamic.aria': 'Couple dynamic: {{label}}. Tap to change',
  'quickSetup.where': 'Where are you?',
  'quickSetup.together': 'Together',
  'quickSetup.apart': 'Apart',
  'quickSetup.mood.heading': "What's the mood?",
  'quickSetup.categories.show': 'Pick categories instead',
  'quickSetup.categories.hide': 'Back to moods',
  'quickSetup.categories.heading': 'Categories',
  'quickSetup.heat': 'How hot?',
  'quickSetup.explicitHint':
    'Levels 7–10 are explicit. Turn on explicit cards in Settings to play them.',
  'quickSetup.explicitHint.link': 'Settings',
  'quickSetup.count': '{{count}} card matches|{{count}} cards match',
  'quickSetup.count.loading': 'Counting cards…',
  'quickSetup.count.mixed': 'A mix of every category',
  'quickSetup.count.custom': 'Ready to play',
  'quickSetup.reason.partner': "Add your partner's name to start",
  'quickSetup.reason.noCards':
    'No cards at this heat level. Try another level or category.',
  'quickSetup.custom': 'Need more control? Custom game',
  'setup.dynamic.maleMale.label': 'Man & Man',
  'setup.dynamic.maleMale.desc': 'Shared prompts until a dedicated deck ships',
  'onboarding.progress': 'Step {{current}} of {{total}}',
  'onboarding.names.title': 'Who is playing?',
  'onboarding.names.body':
    'Names are optional. They make every card feel like it was written for you two.',
  'onboarding.names.you': 'Your name',
  'onboarding.names.partner': "Partner's name",
  'onboarding.names.suggestions': 'Saved partner names',
  'onboarding.gender.title': 'I am',
  'onboarding.gender.woman': 'A woman',
  'onboarding.gender.man': 'A man',
  'onboarding.gender.womanLower': 'a woman',
  'onboarding.gender.manLower': 'a man',
  'onboarding.gender.locked':
    'You play as {{gender}}. This was set once and cannot be changed.',
  'onboarding.partnerGender.title': 'Your partner is',
  'onboarding.partnerGender.body':
    'So the cards fit both of you. You can leave this for later.',
  'onboarding.partnerGender.woman': 'A woman',
  'onboarding.partnerGender.man': 'A man',
  'onboarding.comfort.title': 'How hot should it feel?',
  'onboarding.comfort.body':
    'Only a starting point. You can change it every game.',
  'onboarding.boundaries.title': 'Hide these from our games',
  'onboarding.boundaries.body':
    'Tap anything you would rather not see. You can change this later.',
  'onboarding.boundaries.empty':
    "Categories couldn't load. You can set boundaries later.",
  'onboarding.boundaries.keepOne':
    'Keep at least one category, or there is nothing left to play.',
  'onboarding.boundaries.explicit': 'Show explicit cards',
  'onboarding.boundaries.explicitHint':
    'Off keeps the wildest cards out of the deck.',
  'onboarding.finish': 'Finish',
  'onboarding.saveError':
    "Couldn't save your choices. Check your connection and try again, or skip.",
  'history.customGame': 'Custom game',
  'history.view.label': 'History view',
  'history.view.games': 'By game',
  'history.view.cards': 'All cards',
  'history.status.completed': 'Completed',
  'history.status.paused': 'Paused',
  'history.status.active': 'In progress',
  'history.sessions.failed': "Couldn't load your games.",
  'history.session.rounds': 'Rounds: {{count}}',
  'history.rounds.loading': 'Loading rounds…',
  'history.rounds.failed': "Couldn't load the rounds.",
  'history.rounds.empty': 'No cards were played in this game.',
  'history.round.number': 'Card {{number}}',
  'history.round.skipped': 'Skipped',
  'history.loadMore': 'Show more',

  'settings.replayIntro': 'Replay intro',

  'common.close': 'Close',

  'common.loading': 'Loading...',
  'auth.field.email': 'Email Address',
  'auth.field.password': 'Password',
  'auth.placeholder.email': 'Enter your email',
  'auth.placeholder.password': 'Enter your password',
  'auth.password.show': 'Show password',
  'auth.password.hide': 'Hide password',
  'auth.backToLogin': 'Back to Login',
  'auth.login.title': 'Welcome Back',
  'auth.login.subtitle': 'Sign in to continue your adventure',
  'auth.login.submit': 'Sign In',
  'auth.login.submit.loading': 'Signing In...',
  'auth.login.noAccount': "Don't have an account?",
  'auth.login.createAccount': 'Create Account',
  'auth.login.forgot': 'Forgot your password?',
  'auth.forgot.title': 'Forgot Password?',
  'auth.forgot.subtitle':
    "No worries! Enter your email and we'll send you a reset link.",
  'auth.forgot.placeholder': 'Enter your email address',
  'auth.error.rateLimited':
    'Too many attempts. Please wait a minute and try again.',
  'auth.error.invalidCredentials': 'The email or password is not correct.',
  'auth.error.network': 'No connection. Check your network and try again.',
  'auth.error.generic': 'Something went wrong. Please try again.',
  'auth.forgot.submit': 'Send Reset Link',
  'auth.forgot.submit.loading': 'Sending Reset Link...',
  'auth.forgot.sent.title': 'Check Your Email',
  'auth.forgot.sent.body':
    'If an account exists for that email, we sent a reset link. Click the link in the email to reset your password.',
  'auth.forgot.sent.noEmail': "Didn't receive the email?",
  'auth.forgot.sent.noEmailHint':
    'Check your spam folder or wait a few minutes and try again.',
  'auth.forgot.sent.again': 'Send Another Email',
  'auth.validation.emailRequired': 'Email is required',
  'auth.validation.emailInvalid': 'Please enter a valid email address',

  'auth.field.fullName': 'Full Name',
  'auth.field.confirmPassword': 'Confirm Password',
  'auth.field.dateOfBirth': 'Date of Birth',
  'auth.placeholder.fullName': 'Enter your full name',
  'auth.placeholder.createPassword': 'Create a password',
  'auth.placeholder.confirmPassword': 'Confirm your password',
  'auth.register.title': 'Join the Adventure',
  'auth.register.subtitle': 'Create your account to get started',
  'auth.register.gender.title': 'I am',
  'auth.register.gender.woman': 'A woman',
  'auth.register.gender.man': 'A man',
  'auth.register.gender.hint':
    'This sets which couple pairings you see. It cannot be changed later.',
  'auth.register.ageHint': 'You must be 18 or older to join.',
  'auth.register.consent.prefix': 'I confirm I am 18+ and agree to the',
  'auth.register.consent.link': 'Terms of use',
  'auth.register.consent.suffix': '. This app contains explicit adult content.',
  'auth.register.submit': 'Create Account',
  'auth.register.submit.loading': 'Creating Account...',
  'auth.register.haveAccount': 'Already have an account?',
  'auth.register.signIn': 'Sign In',

  'auth.field.newPassword': 'New Password',
  'auth.field.confirmNewPassword': 'Confirm New Password',
  'auth.placeholder.newPassword': 'Enter your new password',
  'auth.placeholder.confirmNewPassword': 'Confirm your new password',
  'auth.validation.passwordRequired': 'Password is required',
  'auth.validation.passwordMin': 'Password must be at least {{min}} characters',
  'auth.validation.confirmRequired': 'Password confirmation is required',
  'auth.validation.mismatch': 'Passwords do not match',
  'auth.reset.title': 'Reset Your Password',
  'auth.reset.subtitle':
    'Enter your new password below to complete the reset process.',
  'auth.reset.submit': 'Reset Password',
  'auth.reset.submit.loading': 'Resetting Password...',
  'auth.reset.success.title': 'Password Reset Successful!',
  'auth.reset.success.body':
    'Your password has been successfully reset. You can now log in with your new password.',
  'auth.reset.success.goToLogin': 'Go to Login',

  'landing.signIn': 'Sign In',
  'landing.getStarted': 'Play free',
  'landing.badge': 'New Adventure Game for Couples',
  'landing.hero.line1': 'Discover Your',
  'landing.hero.line2': 'Love Adventure',
  'landing.hero.subtitle':
    'Experience the thrill of scratch card challenges designed specifically for couples. Reveal exciting prompts, complete fun tasks, and strengthen your bond together in this immersive romantic adventure.',
  'landing.cta.start': "Play now, it's free",
  'landing.cta.haveAccount': 'Already have an account? Sign in',
  'landing.features.title': 'Why Couples Love This Game',
  'landing.features.subtitle':
    'Designed to bring couples closer together through fun, interactive challenges with immersive experiences',
  'landing.feature.bonds.title': 'Strengthen Bonds',
  'landing.feature.bonds.body':
    'Complete challenges together and discover new ways to connect with your partner through meaningful experiences',
  'landing.feature.fun.title': 'Interactive Fun',
  'landing.feature.fun.body':
    'Scratch cards reveal exciting prompts that keep the adventure fresh and engaging with dynamic animations',
  'landing.feature.shared.title': 'Shared Experience',
  'landing.feature.shared.body':
    'Track your progress together and celebrate achievements as a couple in this beautiful journey',
  'landing.footer.tagline':
    'Making relationships stronger, one adventure at a time',
  'landing.footer.rights': '© {{year}} Gharamiat. All rights reserved.',

  'catalog.title': 'Fantasies',
  'catalog.subtitle':
    'Browse ideas, say what you would try, and see where you match.',
  'catalog.loading': 'Loading catalog…',
  'fantasy.catalog.error': 'Could not load the catalog. Please try again.',

  'catalog.position': 'Position',

  'error.boundary.title': 'Oops! Something went wrong',
  'error.boundary.body':
    "We encountered an unexpected error. Don't worry, it's not your fault!",
  'error.boundary.devDetails': 'Error Details (Development)',
  'error.boundary.errorLabel': 'Error:',
  'error.boundary.stackLabel': 'Stack:',
  'error.boundary.tryAgain': 'Try Again',
  'error.boundary.goHome': 'Go Home',
  'error.boundary.persists': 'If the problem persists, please contact support.',
  'game.undo.reverting': 'Reverting...',
  'scene.storyTime.badge': 'Story time',
  'scene.storyTime.intro': 'Build the scene together, one detail at a time.',
  'scene.fantasyStory.badge': 'Fantasy',
  'scene.fantasyStory.intro': 'Take turns sharing — there’s no wrong answer.',
  'scene.notImplemented': 'Mechanic coming soon',
  'scene.generic.direction.maleToFemale': 'Male → Female',
  'scene.generic.direction.femaleToMale': 'Female → Male',
  'scene.generic.direction.both': 'Either partner',
  'scene.generic.direction.general': 'General',
  'scene.leaf.bedroomConfessions.badge': 'Confession',
  'scene.leaf.bedroomConfessions.intro':
    'Take turns — answer honestly, pause anytime.',
  'scene.leaf.dirtySecrets.badge': 'Secrets',
  'scene.leaf.dirtySecrets.intro':
    'Short answers are fine — keep momentum playful.',
  'scene.leaf.naughtyActions.badge': 'Dare energy',
  'scene.leaf.naughtyActions.intro':
    'Check in with each other; skip beats pressure.',
  'scene.leaf.rolePlay.badge': 'Role play',
  'scene.leaf.rolePlay.intro':
    'Set a vibe, cast your roles one line at a time.',
  'scene.leaf.spicyChallenge.badge': 'Challenge',
  'scene.leaf.spicyChallenge.intro':
    'Escalate only when both confirm the next tier.',
  'scene.leaf.bodyPartKiss.badge': 'Spin',
  'scene.leaf.bodyPartKiss.intro':
    'Let chance pick the moment — negotiate before acting.',
  'scene.leaf.themedAction.badge': 'Themed spin',
  'scene.leaf.themedAction.intro':
    'Use the clue as a playful prompt — adapt to your vibe.',
  'scene.leaf.spinToChooseAToy.badge': 'Toy spin',
  'scene.leaf.spinToChooseAToy.intro': 'Preview before play — curiosity first.',
  'scene.leaf.wouldYouRather.badge': 'Would you rather',
  'scene.leaf.wouldYouRather.intro':
    'Two choices — reveal after both lock in picks.',
  'scene.leaf.sensesUnlocked.badge': 'Senses',
  'scene.leaf.sensesUnlocked.intro':
    'Name limits first; savor one stimulus at a time.',
  'scene.leaf.scratchAdventure.badge': 'Scratch',
  'scene.leaf.scratchAdventure.intro':
    'Reveal lightly — savor the playful surprise.',
  'scene.leaf.revealChallenge.badge': 'Reveal',
  'scene.leaf.revealChallenge.intro':
    'Higher stakes sharing — bail out is always okay.',

  'actions.message.startSession': 'Game started at {{time}}',
  'actions.message.complete':
    '{{player}} completed challenge (+{{points}} points) at {{time}}',
  'actions.message.skip': '{{player}} skipped challenge at {{time}}',
  'actions.message.revert': 'Last action was reverted at {{time}}',
  'actions.message.pauseSession': 'Game paused at {{time}}',
  'actions.message.resumeSession': 'Game resumed at {{time}}',
  'actions.message.completeSession': 'Game completed at {{time}}',
  'actions.message.endSession': 'Session ended at {{time}}',
  'actions.message.unknown': 'Unknown action at {{time}}',
  'actions.challenge': 'Challenge: {{text}}',
  'actions.duration': '{{minutes}}m {{seconds}}s',
  'actions.points': '+{{count}} point|+{{count}} points',

  'scratch.cardHeat': 'Card heat {{level}} — {{label}}',
  'scratch.sessionMood': 'Session mood: level {{level}}',
  'scratch.sessionMood.relaxed':
    'Session mood: level {{level}} (nearest match)',
  'scratch.scratchBelow': 'Scratch below',
  'scratch.rubHint':
    'Rub the purple area to reveal your challenge, position, and details.',
  'scratch.revealed': 'Challenge revealed',
  'scratch.reveal': 'Reveal',
  'scratch.revealAria': 'Reveal the card',
  'scratch.status.loadingNext': 'Loading your next challenge...',
  'scratch.status.passingTurn': 'Passing turn...',
  'scratch.status.doneSolo': 'Challenge complete! Loading next card...',
  'scratch.status.doneCouple': 'Challenge complete! Next player is up.',
  'scratch.progress': '{{percent}}% revealed',
  'scratch.tip': '💡 Tip: Scratch more area to reveal the challenge!',

  'scene.completeRound': 'Complete round',
  'scene.roulette.badge': 'Desire roulette',
  'scene.roulette.hint':
    "Spin to reveal tonight's desire — tap the center or use the button below.",
  'scene.roulette.wheelLabel': 'Desire roulette wheel',
  'scene.roulette.spin': 'Spin the wheel',
  'scene.roulette.result': 'Your desire',
  'scene.wheel.label': 'Prize wheel',
  'scene.wheel.status.spinning': 'Wheel is spinning',
  'scene.wheel.status.result': 'Result: {{label}}',
  'scene.wheel.status.idle': 'Press spin to reveal your desire',
  'scene.wheel.action.spin': 'Spin the wheel',
  'scene.wheel.action.done': 'Wheel already spun',
  'scene.wheel.action.unavailable': 'Spin unavailable',
  'scene.wheel.hub.done': 'Done',
  'scene.wheel.hub.tap': 'Tap',
  'scene.wheel.hub.spin': 'Spin',

  'scene.spinning': 'Spinning…',
  'game.player1': 'Player 1',
  'game.player2': 'Player 2',
  'scene.bottle.badge': 'Spin the Bottle',
  'scene.bottle.hint.idle': 'Spin the bottle to see who goes first!',
  'scene.bottle.hint.reveal': 'The bottle chose…',
  'scene.bottle.winner': '{{name}} goes!',
  'scene.bottle.getReady': 'Get ready for your challenge',
  'scene.bottle.spin': 'Spin the Bottle!',
  'scene.bottle.start': 'Start the Challenge',

  'scene.toy.badge': 'Toy spin',
  'scene.toy.loading': 'Loading toy catalog…',
  'scene.toy.wheelLabel': 'Toy spin wheel',
  'scene.toy.hub': 'Spin',
  'scene.toy.spin': 'Spin the wheel',
  'scene.toy.result': 'Result',
  'scene.toy.loadingOptions': 'Loading options for this outcome…',
  'scene.toy.weChose': 'We picked: {{toy}}',
  'scene.toy.yourPick': 'Your pick: {{toy}}',
  'scene.toy.hint.yourChoice':
    'Choose any toy below that fits what you’re in the mood for.',
  'scene.toy.hint.wildCard': 'Widest mix — here’s something picked for you.',
  'scene.toy.hint.default': 'Here’s something picked from your list.',
  'scene.toy.slice.surprisePick': 'Surprise pick',
  'scene.toy.slice.wildCard': 'Wild card',
  'scene.toy.slice.somethingNew': 'Something new',
  'scene.toy.slice.yourChoice': 'Your choice',
  'scene.toy.slice.mixItUp': 'Mix it up',
  'scene.toy.slice.luckyDip': 'Lucky dip',
  'scene.toy.picker.empty': 'No toys available for this list.',
  'scene.toy.picker.label': 'Choose a toy',
  'scene.toy.picker.hint': 'Tap one to confirm your pick',

  'scene.roulette.generic.softKiss': 'Soft kiss',
  'scene.roulette.generic.deepKiss': 'Deep kiss',
  'scene.roulette.generic.neck': 'Neck',
  'scene.roulette.generic.shoulders': 'Shoulders',
  'scene.roulette.generic.slowTouch': 'Slow touch',
  'scene.roulette.generic.whisper': 'Whisper',
  'scene.roulette.generic.eyeContact': 'Eye contact',
  'scene.roulette.generic.tease': 'Tease',
  'prompt.tag.theme': 'Theme: {{name}}',
  'tag.kink.anal': 'Anal play',
  'tag.kink.authority': 'Authority dynamic',
  'tag.kink.begging': 'Begging',
  'tag.kink.blindfold': 'Blindfold / sensory deprivation',
  'tag.kink.bondage': 'Bondage',
  'tag.kink.breeding': 'Breeding fantasy (talk only)',
  'tag.kink.chastity': 'Chastity play',
  'tag.kink.clothedSex': 'Clothed sex',
  'tag.kink.collaring': 'Collaring',
  'tag.kink.consentCheck': 'Consent check-in',
  'tag.kink.cuckold': 'Cuckold / hotwife fantasy',
  'tag.kink.degradation': 'Degradation',
  'tag.kink.domSub': 'Dom / sub',
  'tag.kink.exhibition': 'Exhibitionism',
  'tag.kink.exploration': 'Kink exploration',
  'tag.kink.faceSitting': 'Face sitting',
  'tag.kink.feet': 'Foot / leg fetish',
  'tag.kink.foodPlay': 'Food play',
  'tag.kink.gags': 'Gags / silence',
  'tag.kink.group': 'Group / threesome fantasy',
  'tag.kink.hairPulling': 'Hair pulling',
  'tag.kink.impact': 'Impact play',
  'tag.kink.joi': 'JOI / guided masturbation',
  'tag.kink.lingerie': 'Lingerie fetish',
  'tag.kink.marking': 'Marking / biting',
  'tag.kink.mirror': 'Mirror sex',
  'tag.kink.mood': 'Mood setting',
  'tag.kink.narration': 'Dirty talk / narration',
  'tag.kink.negotiation': 'Consent negotiation',
  'tag.kink.orgasmControl': 'Orgasm control / edging',
  'tag.kink.pegging': 'Pegging / strap-on',
  'tag.kink.petPlay': 'Pet play',
  'tag.kink.phoneSex': 'Phone / audio erotica',
  'tag.kink.praise': 'Praise kink',
  'tag.kink.publicRisk': 'Semi-public risk',
  'tag.kink.quietSex': 'Quiet / secret sex',
  'tag.kink.rimming': 'Rimming / anilingus',
  'tag.kink.roleplay': 'Role play',
  'tag.kink.secret': 'Secret thrill',
  'tag.kink.sensation': 'Sensation play',
  'tag.kink.stranger': 'Stranger fantasy',
  'tag.kink.teasing': 'Teasing',
  'tag.kink.temperature': 'Temperature play',
  'tag.kink.toys': 'Toys',
  'tag.kink.uniform': 'Uniform / clothing fetish',
  'tag.kink.voyeur': 'Voyeurism',
  'tag.kink.wax': 'Wax play',
  'tag.kink.worship': 'Body worship',
  'tag.format.action': 'Action or dare prompt',
  'tag.format.question': 'Question or truth prompt',
  'tag.format.story': 'Storytelling',
  'tag.format.wouldYouRather': 'Would you rather',
  'tag.intensity.rough': 'Rough or intense',
  'tag.mechanic.chance': 'Chance or random mechanic',
  'tag.pacing.slow': 'Slow pacing',
  'tag.tone.egyptianSlang': 'Egyptian slang',
  'tag.tone.explicitLanguage': 'Explicit language',
  'tag.tone.romanticSoft': 'Romantic or soft',
  'tag.tone.vulnerable': 'Vulnerable or emotional',
  'tag.position.allOral': 'All oral',
  'tag.position.allSex': 'All sex',
  'tag.position.athletic': 'Athletic',
  'tag.position.breastAccess': 'Breast access',
  'tag.position.clitAccess': 'Clit access',
  'tag.position.faceToFace': 'Face to face',
  'tag.position.frontEntry': 'Front entry',
  'tag.position.manActive': 'Man active',
  'tag.position.manBridged': 'Man bridged',
  'tag.position.manKneeling': 'Man kneeling',
  'tag.position.manLying': 'Man lying',
  'tag.position.manOnTop': 'Man on top',
  'tag.position.manSitting': 'Man sitting',
  'tag.position.manSquatting': 'Man squatting',
  'tag.position.manStanding': 'Man standing',
  'tag.position.neitherOnTop': 'Side by side',
  'tag.position.rearEntry': 'Rear entry',
  'tag.position.spankingAccess': 'Spanking access',
  'tag.position.twistedEntry': 'Twisted entry',
  'tag.position.womanActive': 'Woman active',
  'tag.position.womanBridged': 'Woman bridged',
  'tag.position.womanKneeling': 'Woman kneeling',
  'tag.position.womanLying': 'Woman lying',
  'tag.position.womanOnTop': 'Woman on top',
  'tag.position.womanSitting': 'Woman sitting',
  'tag.position.womanSquatting': 'Woman squatting',
  'tag.position.womanStanding': 'Woman standing',
  'tag.theme.kinks': 'Kinks & fetishes',
  'tag.theme.appreciation': 'Compliments or appreciation',
  'tag.theme.bathroomWater': 'Bathroom or water',
  'tag.theme.bedroom': 'Bedroom',
  'tag.theme.bodyConfidence': 'Body confidence',
  'tag.theme.bodyFocus': 'Body or erogenous focus',
  'tag.theme.communication': 'Communication',
  'tag.theme.confession': 'Confession',
  'tag.theme.confidence': 'Confidence',
  'tag.theme.consentBoundaries': 'Consent and boundaries',
  'tag.theme.desire': 'Desire',
  'tag.theme.dreams': 'Dreams',
  'tag.theme.endurance': 'Endurance',
  'tag.theme.fantasy': 'Fantasy',
  'tag.theme.intensity': 'Intensity',
  'tag.theme.intimacy': 'Intimacy',
  'tag.theme.kiss': 'Kissing',
  'tag.theme.massage': 'Massage',
  'tag.theme.memory': 'Memories or past',
  'tag.theme.oral': 'Oral sex',
  'tag.theme.orgasm': 'Orgasm focus',
  'tag.theme.passion': 'Passion',
  'tag.theme.positions': 'Positions',
  'tag.theme.publicRisk': 'Public or risk',
  'tag.theme.restraint': 'Restraint or bondage',
  'tag.theme.roleplay': 'Role play',
  'tag.theme.sensesGame': 'Senses game',
  'tag.theme.sensory': 'Sensory',
  'tag.theme.touch': 'Touch',
  'tag.theme.toys': 'Toys',
  'tag.theme.trust': 'Trust',
  'tag.theme.undressing': 'Undressing',
  'tag.theme.voyeurEyeContact': 'Watching or eye contact',
  'tag.theme.whisper': 'Whisper or ear',

  'fantasyExplorer.loading': 'Loading fantasies catalog…',
  'fantasyExplorer.ratingQuestion': 'How do you feel about this idea?',
  'fantasyExplorer.syncError': 'Could not sync to server.',
  'fantasyExplorer.intro.solo':
    'Pick up to three fantasies: start from a theme, explore it, dig into a variation. Then rate how much each one appeals to you. It is private to you.',
  'fantasyExplorer.intro.couple':
    'Each of you picks up to three fantasies, one after the other on this phone: first {{player1}}, then {{player2}}. Then you see where you overlap and each rate your own picks.',
  'fantasyExplorer.picker.title': '{{name}}, choose up to {{count}} fantasies',
  'fantasyExplorer.picker.stepThemes': 'Step 1 · Choose a theme',
  'fantasyExplorer.picker.stepExplore': 'Step 2 · Explore',
  'fantasyExplorer.picker.stepDig': 'Step 3 · Dig deeper',
  'fantasyExplorer.picker.recommended.title': 'Recommended for you',
  'fantasyExplorer.picker.recommended.body':
    'A quick start: one opening idea from each of the first three themes. It is only a suggestion, and you can change any of it.',
  'fantasyExplorer.picker.recommended.use': 'Use these picks',
  'fantasyExplorer.picker.recommended.applied': 'Suggestion added below',
  'fantasyExplorer.picker.suggestedNote': 'Suggested for you. Edit freely.',
  'fantasyExplorer.picker.pickedIn': '{{count}} picked',
  'fantasyExplorer.picker.backToThemes': 'All themes',
  'fantasyExplorer.picker.backTo': 'Back to {{name}}',
  'fantasyExplorer.picker.digDeeper': 'Dig deeper',
  'fantasyExplorer.picker.narrowedTo': 'Narrowed to {{name}}',
  'fantasyExplorer.picker.removePick': 'Remove from my picks',
  'fantasyExplorer.picker.yourPicks': 'Your picks',
  'fantasyExplorer.picker.empty':
    'Nothing yet. Choose a theme, or use the recommended picks.',
  'fantasyExplorer.picker.remove': 'Remove {{name}}',
  'fantasyExplorer.picker.full':
    'That is {{count}} picks. Remove one to add another.',
  'fantasyExplorer.picker.confirm': 'Lock in my picks',
  'fantasyExplorer.begin': 'Begin',
  'fantasyExplorer.refine.keepBroad': 'Keep broader theme only',
  'fantasyExplorer.refine.cta.solo': 'Rate your picks',
  'fantasyExplorer.refine.cta.passPhone': 'Pass phone to Partner B',
  'fantasyExplorer.refine.cta.overlap': 'See overlap preview',
  'fantasyExplorer.handoff.prefix': 'Give the device to',
  'fantasyExplorer.handoff.suffix':
    '. Don’t glance at Partner A’s picks — honesty keeps it fun.',
  'fantasyExplorer.handoff.ready': '{{name}} ready to pick',
  'fantasyExplorer.overlap.title': 'Conversation starters',
  'fantasyExplorer.overlap.hint':
    'Overlaps invite curiosity — not homework. Celebrate alignment; explore soft overlaps gently.',
  'fantasyExplorer.overlap.computing': 'Computing shared themes…',
  'fantasyExplorer.overlap.aligned': 'Aligned details',
  'fantasyExplorer.overlap.noAligned': 'No identical leaf matches yet.',
  'fantasyExplorer.overlap.soft': 'Same theme · different twist',
  'fantasyExplorer.overlap.noSoft': 'None surfaced.',
  'fantasyExplorer.overlap.broad': '(broad)',
  'fantasyExplorer.overlap.continue': 'Continue to reveal pacing',
  'fantasyExplorer.reveal.hint':
    'Take turns naming what intrigued you — no debating scores yet. Ratings are private next.',
  'fantasyExplorer.reveal.start': 'Start personal ratings ({{name}})',
  'fantasyExplorer.rate.title': '{{name}} — rate your picks',
  'fantasyExplorer.rate.nextPartner': "{{name}}'s ratings next",
  'fantasyExplorer.rate.finish': 'Finish',
  'fantasyExplorer.rate.handoff.prefix': 'Hand to',
  'fantasyExplorer.rate.handoff.suffix':
    ' — they’ll score only their fantasies, unseen by you till you choose to chat.',
  'fantasyExplorer.rate.complete': 'Complete session',
  'fantasyExplorer.done.title': 'Thanks for exploring',
  'fantasyExplorer.done.body':
    'Your picks and reactions are synced to this session — lovely fuel for future play ideas.',
  'fantasyExplorer.done.leave': 'Leave game setup',

  'nav.menu.open': 'Open menu',
  'nav.menu.close': 'Close menu',
  'nav.secondary': 'Secondary navigation',
  'nav.primary': 'Primary navigation',
  'nav.more': 'More',
  'nav.moreNavigation': 'More navigation',
  'nav.help': 'Help',
  'game.actions': 'Game actions',
  'game.promptLoading': 'Loading prompt…',
  'settings.role.admin': 'Admin',
  'settings.role.user': 'User',

  'lock.title': 'Enter PIN',
  'lock.keypad': 'Numeric keypad',
  'lock.backspace': 'Delete last digit',
  'lock.entered': '{{count}} of {{total}} digits entered',
  'lock.wrong':
    'Wrong PIN. {{count}} attempt left.|Wrong PIN. {{count}} attempts left.',
  'lock.lockedOut': 'Too many attempts. Signing you out.',

  'security.title': 'Privacy & safety',
  'security.subtitle': 'Keep your game private on this device',
  'security.pin.title': 'App lock',
  'security.pin.desc':
    'Ask for a PIN when the app opens and after it has been in the background.',
  'security.pin.status.on': 'PIN is on',
  'security.pin.status.off': 'PIN is off',
  'security.pin.set': 'Set PIN',
  'security.pin.change': 'Change PIN',
  'security.pin.remove': 'Remove PIN',
  'security.pin.current': 'Current PIN',
  'security.pin.new': 'New PIN (4 to 6 digits)',
  'security.pin.confirm': 'Repeat new PIN',
  'security.pin.save': 'Save PIN',
  'security.pin.removeConfirm': 'Remove PIN',
  'security.pin.error.format': 'Use 4 to 6 digits.',
  'security.pin.error.mismatch': 'The PINs do not match.',
  'security.pin.saved': 'PIN saved',
  'security.pin.removed': 'PIN removed',
  'security.pin.unsupported': 'PIN lock needs a secure (HTTPS) connection.',
  'security.autolock.label': 'Auto-lock',
  'security.autolock.desc': 'Lock after the app has been in the background for',
  'security.autolock.option1': '1 minute',
  'security.autolock.option5': '5 minutes',
  'security.autolock.option15': '15 minutes',
  'security.autolock.optionNever': 'Never',
  'security.discreet.title': 'Discreet mode',
  'security.discreet.desc':
    'Shows "Notes" as the browser tab name and hides images.',
  'security.haptics.label': 'Enable haptics (vibration)',

  'ageGate.title': 'Adults only',
  'ageGate.body':
    'This app contains explicit content for couples. You must be 18 or older to continue.',
  'ageGate.confirm': 'I am 18 or older',
  'ageGate.leave': 'Leave',
  'ageGate.explicit.reveal': 'Tap to reveal',
  'ageGate.explicit.hint': 'This image may be explicit.',

  'decoy.title': 'Notes',
  'decoy.new': 'New note',
  'decoy.search': 'Search notes',
  'decoy.back': 'All notes',
  'decoy.placeholder': 'Start typing…',
  'decoy.open': 'Open',
  'decoy.untitled': 'Untitled',
  'decoy.note1.title': 'Groceries',
  'decoy.note1.body': 'Milk, eggs, bread, coffee, tomatoes',
  'decoy.note2.title': 'Weekend plans',
  'decoy.note2.body': 'Call mom. Laundry. Long walk if it stays sunny.',
  'decoy.note3.title': 'Book ideas',
  'decoy.note3.body': 'Something about the sea. Re-read the old favourites.',

  'account.title': 'Account',
  'account.subtitle': 'Your email, your data and your account',
  'account.verify.title': 'Verify your email',
  'account.verify.body':
    'We sent a link to {{email}}. Verify it to secure your account.',
  'account.verify.resend': 'Resend email',
  'account.verify.sending': 'Sending…',
  'account.verify.sent': 'Verification email sent.',
  'account.verify.success': 'Your email is verified.',
  'account.verify.verified': 'Email verified',
  'account.verify.error': 'Could not send the email. Please try again.',
  'account.export.title': 'Export my data',
  'account.export.desc':
    'Download your settings, games and fantasies as a JSON file.',
  'account.export.button': 'Export my data',
  'account.export.busy': 'Exporting…',
  'account.export.done': 'Your data was downloaded.',
  'account.export.error': 'Could not export your data. Please try again.',
  'account.export.truncated':
    'Your export was saved, but it is partial: very long lists were cut short.',
  'account.install.title': 'Install the app',
  'account.install.desc':
    'Add Gharamiat to your home screen to open it like any other app.',
  'account.delete.title': 'Delete my account',
  'account.delete.desc':
    'Permanently removes your account and personal data. This cannot be undone.',
  'account.delete.button': 'Delete my account',
  'account.delete.sheetTitle': 'Delete your account?',
  'account.delete.warning':
    'Your account and personal data will be removed for good. This cannot be undone.',
  'account.delete.password': 'Confirm with your password',
  'account.delete.confirm': 'Delete forever',
  'account.delete.busy': 'Deleting…',
  'account.delete.wrongPassword': 'That password is not correct.',
  'account.delete.done': 'Your account was deleted.',
  'account.error.network': 'No connection. Check your network and try again.',
  'account.error.generic': 'Something went wrong. Please try again.',

  'game.round.short': 'R{{round}}',
  'game.action.done': 'Done',
  'game.toast.done': 'Done',
  'game.toast.skipped': 'Skipped',
  'game.toast.undo': 'Undo',
  'game.scorePair': 'Score: {{name1}} {{score1}}, {{name2}} {{score2}}',
  'game.scoreSolo': 'Score: {{score}}',
  'game.pauseFailed': "Couldn't save the pause. The game is still active.",
  'game.more.title': 'Game menu',
  'game.more.undo': 'Undo last',
  'game.more.history': 'History',
  'game.more.pause': 'Pause',
  'game.more.quickHandoff': 'Quick handoff',
  'game.more.quickHandoff.desc':
    'Moves on by itself a moment after you pass the phone',
  'game.more.sound': 'Sound',
  'game.more.haptics': 'Vibration',
  'game.end.title': 'End this game?',
  'game.completed.title': 'This game has ended',
  'game.end.winner': '{{name}} wins!',
  'game.end.tie': "It's a tie",
  'game.end.solo': 'You scored {{score}}',
  'game.end.rounds': '{{count}} round played|{{count}} rounds played',
  'game.end.playAgain': 'Play again',
  'game.end.backHome': 'Back home',
  'game.end.keepPlaying': 'Keep playing',
  'game.handoff.title': 'Pass the phone to {{name}}',
  'game.handoff.ready': "I'm {{name}}, ready",
  'game.handoff.hint': 'The next card stays hidden until you tap.',
  'game.handoff.countdown': 'Continuing in a moment',
  'game.timer.label': 'Time left',
  'game.timer.start': 'Start timer',
  'game.timer.up': "Time's up",
  'consent.line.skip': 'Either of you can skip any card, no questions asked.',
  'consent.line.safeWord': 'Say the safe word to stop immediately: {{word}}',
  'consent.line.private': 'Everything stays between you two.',
  'consent.safeWord.default': 'pause',
  'checkin.title': 'Still good?',
  'checkin.body':
    'Round {{round}}: a quick check-in. How are you both feeling?',
  'checkin.keepGoing': 'Keep going',
  'checkin.dialDown': 'Dial it down',
  'checkin.done': "We're done",
  'checkin.dialDown.applied': 'Turned the heat down a little.',
  'checkin.dialDown.floor': 'Already at the gentlest level you picked.',
  'checkin.dialDown.failed':
    "Couldn't change the heat level. Carrying on as before.",

  'setup.spice.fineTune': 'Fine-tune',

  // --- Phase 2: couple pairing and two-device play ---
  'nav.play': 'Play',
  'nav.partner': 'Partner',
  'dashboard.partner.paired': 'Paired with {{name}}',
  'dashboard.partner.online': '{{name}} is online',
  'dashboard.partner.openPartner': 'Open the partner tab',
  'partner.title': 'Your partner',
  'partner.subtitle.unpaired':
    'Pair your phones to play together, even from different places.',
  'partner.subtitle.paired':
    'You are paired. Play on two phones, wave hello, or send a nudge.',
  'partner.loading': 'Loading your partner...',
  'partner.loadFailed': 'We could not load your pairing details.',
  'partner.invite.title': 'Invite your partner',
  'partner.invite.body':
    'Create a code and send it to your partner. It stays valid for 24 hours.',
  'partner.invite.create': 'Create invite code',
  'partner.invite.creating': 'Creating...',
  'partner.invite.codeLabel': 'Invite code {{code}}',
  'partner.invite.copy': 'Copy code',
  'partner.invite.copyLink': 'Copy link',
  'partner.invite.copied': 'Copied',
  'partner.invite.copyFailed':
    'Could not copy. Select the code and copy it by hand.',
  'partner.invite.share': 'Share',
  'partner.invite.shareTitle': 'Join me on Gharamiat',
  'partner.invite.shareText':
    'Use my code {{code}} to pair with me on Gharamiat.',
  'partner.invite.qrLabel': 'QR code for your invite link',
  'partner.invite.waiting': 'Waiting for your partner to enter the code...',
  'partner.invite.expires': 'Valid for 24 hours',
  'partner.join.title': 'I have a code',
  'partner.join.body': 'Enter the 6-character code your partner sent you.',
  'partner.join.groupLabel': 'Invite code',
  'partner.join.digit': 'Character {{index}} of {{total}}',
  'partner.join.submit': 'Pair up',
  'partner.join.submitting': 'Pairing...',
  'partner.error.alreadyCoupled':
    'You are already paired with someone. Unlink first to pair again.',
  'partner.error.ownInvite':
    'That is your own code. Send it to your partner instead.',
  'partner.error.inviteAlreadyUsed':
    'That code has already been used. Ask your partner for a new one.',
  'partner.error.inviteNotFound':
    'We could not find that code. Check it and try again; it may have expired.',
  'partner.error.noActiveCouple': 'You are not paired right now.',
  'partner.error.emailUnverified': 'Verify your email address before pairing.',
  'partner.error.codeRequired': 'Enter all 6 characters of the code.',
  'partner.error.wrongPassword': 'That password is not right.',
  'partner.error.tooManyAttempts':
    'Too many wrong codes. Please wait a few minutes before trying again.',
  'partner.error.rateLimited':
    'Too many tries. Please wait a little and try again.',
  'partner.error.network': 'Could not reach the server. Check your connection.',
  'partner.error.unknown': 'Something went wrong. Please try again.',
  'partner.toast.paired': 'You are now paired with {{name}}!',
  'partner.toast.unlinked': 'You are no longer paired.',
  'partner.card.avatar': 'Avatar of {{name}}',
  'partner.status.online': 'Online now',
  'partner.status.offline': 'Offline',
  'partner.status.lastSeen': 'Last seen {{time}}',
  'partner.lastSeen.now': 'just now',
  'partner.lastSeen.minutes': '{{count}} min ago',
  'partner.lastSeen.hours': '{{count}} h ago',
  'partner.lastSeen.days': '{{count}} d ago',
  'partner.play.now': 'Play together now',
  'partner.nudge.button': 'Nudge',
  'hostSetup.title': '{{name}} sets up your games',
  'hostSetup.body': "You'll join as soon as it starts.",
  'hostSetup.sheetHint': '{{name}} sets up games for the two of you.',
  'partner.nudge.title': 'Send a nudge to {{name}}',
  'partner.nudge.wave': 'Wave hello',
  'partner.nudge.wave.desc': 'A quick, friendly hello',
  'partner.nudge.missYou': 'I miss you',
  'partner.nudge.missYou.desc': 'Let them know you are thinking of them',
  'partner.nudge.playNow': "Let's play",
  'partner.nudge.playNow.desc': 'Invite them to join you now',
  'partner.nudge.sent': 'Sent to {{name}}',
  'partner.nudge.wait': 'You can send another in {{seconds}}s',
  'partner.unlink.button': 'Unlink',
  'partner.unlink.title': 'Unlink from {{name}}?',
  'partner.unlink.body':
    'Shared games end for both of you and you will need a new code to pair again.',
  'partner.unlink.password': 'Your password',
  'partner.unlink.confirm': 'Unlink',
  'partner.unlink.busy': 'Unlinking...',
  'pair.title': 'Pair with your partner',
  'pair.subtitle': 'Check the code below, then tap to pair your accounts.',
  'pair.noCode':
    'This link has no code. Ask your partner to send it again, or type the code yourself.',
  'pair.goPartner': 'Go to the partner tab',
  'safetyNote.label': 'Before you start',
  'waitingRoom.title': 'Your game is almost ready',
  'waitingRoom.summary': 'Game settings',
  'waitingRoom.deck': 'Deck',
  'waitingRoom.deckMixed': 'A mix of everything',
  'waitingRoom.heat': 'Heat',
  'waitingRoom.heatAny': 'Any level',
  'waitingRoom.heatLevel': 'Level {{level}}',
  'waitingRoom.players': 'Players',
  'waitingRoom.where': 'Where',
  'waitingRoom.waiting': 'Waiting for {{name}} to start...',
  'lobby.title': 'Ready when you are',
  'lobby.players': 'Players in this game',
  'lobby.you': '{{name}} (you)',
  'lobby.here': 'Online',
  'lobby.notHere': 'Not online yet',
  'lobby.waiting': 'Waiting for {{name}}...',
  'lobby.hint':
    '{{name}} sees a Join button on their home screen. Tap Start now when you are both ready; the game opens by itself on their phone.',
  'lobby.copyLink': 'Copy link',
  'lobby.linkCopied': 'Link copied',
  'lobby.nudge': 'Nudge {{name}}',
  'lobby.nudgeSent': 'Nudge sent',
  'lobby.startNow': 'Start now',
  'lobby.starting': 'Starting...',
  'lobby.leave': 'Back home',
  'twoDevice.join.label': 'Your partner is waiting',
  'twoDevice.join.title': "Join {{name}}'s game",
  'twoDevice.join.started': '{{name}} started a game',
  'twoDevice.join.button': 'Join game',
  'twoDevice.remoteChip': 'Over the call',
  'twoDevice.waitingFor': 'Waiting for {{name}}...',
  'twoDevice.sharedCard': 'This card is shown on both phones',
  'twoDevice.reactions.label': 'Send a reaction',
  'twoDevice.reaction.send': 'Send {{emoji}}',
  'twoDevice.reaction.failed': 'Could not send that reaction.',
  'twoDevice.nudge.button': 'Nudge {{name}}',
  'twoDevice.nudge.sent': 'Nudge sent',
  'twoDevice.nudge.failed': 'Could not send the nudge.',
  'twoDevice.secret.title': 'Secret card for {{name}}',
  'twoDevice.secret.body':
    'Only {{name}} can see this one. Wait for the reveal.',
  'twoDevice.flash.done': '{{name}} did it! +{{points}}',
  'twoDevice.flash.skipped': '{{name}} skipped',
  'twoDevice.error.notYourTurn': 'It is not your turn. We refreshed the game.',
  'twoDevice.error.staleCard': 'The card changed. Showing the latest one.',
  'twoDevice.error.noCurrentCard':
    'The card was not ready yet. Getting it now.',
  'twoDevice.paused.title': 'Game paused',
  'twoDevice.paused.body':
    'One of you paused the game. Resume when you are both ready.',
  'twoDevice.paused.resume': 'Resume',
  'twoDevice.paused.home': 'Back home',
  'twoDevice.ended.title': 'Game over',
  'twoDevice.ended.note': 'This game was ended. Here is how it went.',
  'twoDevice.loadingCard': 'Getting the next card...',
  'realtime.live': 'Live',
  'realtime.syncing': 'Syncing',
  'realtime.offline': 'Offline',
  'realtime.announce.live': 'Connected live to your partner',
  'realtime.announce.syncing': 'Syncing with your partner',
  'realtime.announce.offline': 'You are offline',
  'realtime.nudge.wave': '{{name}} waved at you',
  'realtime.nudge.missYou': '{{name}} misses you',
  'realtime.nudge.playNow': '{{name}} wants to play',
  'realtime.nudge.inGame': '{{name}} is waiting for you',
  'realtime.nudge.join': 'Join',
  'realtime.nudge.noGame': 'There is no game to join right now.',
  'quickSetup.apart.pairFirst': 'Pair with your partner first',
  'quickSetup.apart.desc': 'Each on your own phone, over a call.',
  'quickSetup.room.label': 'Two phones, same room',
  'quickSetup.room.desc': 'Each of you plays on your own phone.',
  'quickSetup.reason.notPaired':
    'Pair with your partner to play on two phones.',
  'pwa.update.available': 'A new version is ready',
  'pwa.update.action': 'Update',
  'pwa.offline.banner':
    'You are offline — your game will resume when you are back',
  'pwa.offline.bannerDiscreet': 'You are offline',
  'pwa.install.action': 'Install app',
  'pwa.install.iosHint': 'Share → Add to Home Screen',

  'notFound.title': 'Page not found',
  'notFound.body':
    'The page you are looking for does not exist, or it has moved.',
  'notFound.home': 'Back to start',
  'notFound.help': 'Help centre',

  'app.route.loading': 'Loading...',

  'api.status.unavailable':
    'The service is temporarily unavailable (maintenance). Please try again in a few minutes.',
  'auth.error.unavailable':
    'The service is temporarily unavailable. Please try again in a few minutes.',

  'legal.nav.label': 'Legal information',
  'legal.link.terms': 'Terms of use',
  'legal.link.privacy': 'Privacy policy',
  'legal.link.cookies': 'Cookies and storage',
  'legal.link.age': '18+ only',
  'auth.register.consent.and': ' and the ',
  'auth.register.consent.linkPrivacy': 'Privacy policy',

  'fantasy.tabs.label': 'Fantasies view',
  'fantasy.tabs.explore': 'Explore',
  'fantasy.tabs.matches': 'Our matches',
  'fantasy.answer.love': "Yes, let's try",
  'fantasy.answer.maybe': 'Maybe, curious',
  'fantasy.answer.no': 'Not for me',
  'fantasy.answer.group': 'Your answer to {{title}}',
  'fantasy.answer.question': 'Would you try this?',
  'fantasy.answer.save.error': 'Could not save your answer. Please try again.',
  'fantasy.answer.save.rateLimited':
    'Too many taps. Wait a moment and try again.',
  'fantasy.explore.progress': 'You answered {{answered}} of {{total}}',
  'fantasy.explore.privacy':
    'Your answers are saved to your account. Your partner never sees a "Not for me" unless you choose to share it.',
  'fantasy.answers.loadError': 'Could not load your answers.',
  'fantasy.matches.pairFirst.title': 'Matches need two',
  'fantasy.matches.pairFirst.body':
    'Pair with your partner to see what you both want to try.',
  'fantasy.matches.pairFirst.cta': 'Go to Partner',
  'fantasy.matches.loading': 'Loading your matches…',
  'fantasy.matches.loadError': 'Could not load your matches.',
  'fantasy.matches.progress.mine': 'You answered {{answered}} of {{total}}',
  'fantasy.matches.progress.partner':
    '{{name}} answered {{answered}} of {{total}}',
  'fantasy.matches.both.title': 'You both want to try',
  'fantasy.matches.curious.title': 'One of you is curious',
  'fantasy.matches.you': 'You: {{answer}}',
  'fantasy.matches.partner': '{{name}}: {{answer}}',
  'fantasy.matches.empty.title': 'No matches yet',
  'fantasy.matches.empty.body':
    'A match appears when you both say "Love to try" or "Maybe, curious" to the same fantasy.',
  'fantasy.matches.empty.cta': 'Explore fantasies',
  'fantasy.matches.privacy':
    'Only matches are shared. A "Not for me" stays private, and so does any fantasy only one of you answered.',
  'fantasy.matches.others.title': "{{name}}'s other answers",
  'fantasy.matches.others.body': '{{name}} chose to share all their answers.',
  'fantasy.share.label':
    'Let {{name}} see all my answers, including "Not for me"',
  'fantasy.share.help':
    'Off by default. While it is on, {{name}} can see every answer you give. Matches are always shown to both of you.',
  'fantasy.share.error': 'Could not save this setting. Please try again.',
  'fantasyExplorer.done.matches.title': 'Your matches from this game',
  'fantasyExplorer.done.matches.empty':
    'No matches this time. Your answers are saved in Fantasies.',
  'fantasyExplorer.done.seeAll': 'See all our matches',
  'exploration.picker.title': '{{name}}, pick up to {{count}} fantasies',
  'exploration.picker.secret':
    'Your picks stay secret until you both lock them in.',
  'exploration.picker.pickedIn': '{{count}} picked',
  'exploration.picker.variationOf': 'Variation of {{name}}',
  'exploration.picker.yourPicks': 'Your picks',
  'exploration.picker.counter': '{{selected}} of {{total}} picked',
  'exploration.picker.empty': 'Tap a card to pick it. Up to {{count}}.',
  'exploration.picker.full':
    'That is {{count}}, the most you can pick. Remove one to pick another.',
  'exploration.picker.remove': 'Remove {{name}}',
  'exploration.picker.lock': 'Lock in my picks',
  'exploration.picker.locking': 'Locking in…',
  'exploration.wait.picks': '{{name}} is still picking…',
  'exploration.wait.picksCount': 'Picked so far: {{count}}',
  'exploration.wait.picksHint':
    "Your picks are locked in and secret. You will see {{name}}'s picks as soon as they are locked in too.",
  'exploration.wait.yourPicks': 'Your locked picks',
  'exploration.wait.answers': "Waiting for {{name}}'s answers…",
  'exploration.wait.answersHint':
    'Your answers are sent. The results show up here as soon as {{name}} is done.',
  'exploration.respond.loading': 'Getting the picks…',
  'exploration.respond.intro':
    'Here is what {{name}} picked. Tell them how you feel about each one. There are no wrong answers.',
  'exploration.respond.pickedBy': '{{name}} picked',
  'exploration.respond.progress': '{{current}} of {{total}}',
  'exploration.respond.bothBadge': 'You both picked this!',
  'exploration.respond.bothNote':
    'It counts as a yes from both of you. Nothing to answer.',
  'exploration.respond.back': 'Back',
  'exploration.respond.next': 'Next',
  'exploration.respond.remaining':
    'One left to answer|{{count}} left to answer',
  'exploration.respond.send': 'Send my answers',
  'exploration.respond.sending': 'Sending…',
  'exploration.respond.nothing':
    'You picked the same fantasies, so there is nothing to answer.',
  'exploration.results.title': 'What you found together',
  'exploration.results.intro':
    'Answers are shown kindly. A no stays gentle, with no pressure.',
  'exploration.results.both': 'You both want to try',
  'exploration.results.maybe': "Maybe, let's talk",
  'exploration.results.fantasy': 'Keep it a fantasy',
  'exploration.results.no.partner': 'Not for {{name}}',
  'exploration.results.no.you': 'Not for you',
  'exploration.results.no.note': 'Totally fine. Nothing to follow up on.',
  'exploration.results.pickedByYou': 'You picked this',
  'exploration.results.pickedByName': '{{name}} picked this',
  'exploration.results.bothPicked': 'You both picked this',
  'exploration.results.loading': 'Putting your results together…',
  'exploration.results.error': 'Could not load your results.',
  'exploration.results.empty': 'Nothing to show this time.',
  'exploration.results.seeAll': 'See all our matches',
  'exploration.results.playAgain': 'Play again',
  'exploration.results.askHost': 'Ask {{name}} to start another round.',
  'exploration.results.backHome': 'Back home',
  'exploration.error.notYourSeat': 'That belongs to your partner.',
  'exploration.error.tooManyPicks': 'That is more picks than allowed.',
  'exploration.error.picksRequired': 'Pick at least one fantasy first.',
  'exploration.error.unknownFantasy':
    'One of those fantasies is no longer available. Pick again.',
  'exploration.error.picksLocked': 'Your picks are already locked in.',
  'exploration.error.notPartnerPick':
    "That one is not one of your partner's picks.",
  'exploration.error.responsesIncomplete': 'Answer every card before you send.',
  'exploration.error.responsesLocked': 'Your answers are already sent.',
  'exploration.error.notResponding':
    'Answers open once you have both locked in your picks.',
  'exploration.error.twoDevicesOnly':
    'Fantasy Exploration needs two paired phones.',
  'exploration.error.conflict':
    'The game just changed. Take another look and try again.',
  'exploration.error.sync':
    'Could not save. Check your connection and try again.',
  'exploration.error.unavailable':
    'Fantasy Exploration is not available right now.',
  'exploration.tile.title': 'Fantasy Exploration',
  'exploration.tile.body':
    "You each pick up to 5 fantasies in secret. Then you answer each other's picks, gently.",
  'exploration.tile.start': 'Start exploring',
  'exploration.tile.starting': 'Starting…',
  'exploration.tile.guest': 'Ask {{name}} to start',
  'exploration.tile.guestBody':
    'Whoever invited you starts it. It opens on your phone by itself.',
  'exploration.tile.pair': 'Pair with your partner to explore together',
  'exploration.tile.pairCta': 'Go to Partner',
  'exploration.partner.button': 'Start a Fantasy Exploration',
  'fantasy.answer.fantasy': 'Only as a fantasy',
  'fantasy.matches.fantasy.title': 'Keep it a fantasy',
  'realtime.fantasyMatch.new': 'New match with {{name}}!',
  'realtime.fantasyMatch.view': 'View',
  'guest.cta.play': 'Play as a guest',
  'guest.start.title': 'Play now, no account needed',
  'guest.start.subtitle':
    'Just your name and who you are. It is free, and you can add an email later.',
  'guest.start.name': 'Your name',
  'guest.start.namePlaceholder': 'What should your partner call you?',
  'guest.start.consent.prefix':
    'By continuing you confirm you are 18 or older and agree to the',
  'guest.start.consent.suffix': '.',
  'guest.start.submit': 'Start playing',
  'guest.start.submit.loading': 'Starting…',
  'guest.start.note':
    'Your guest profile stays on this phone. Add an email later to keep it safe.',
  'guest.start.haveAccount': 'Already have an account? Sign in',
  'guest.profile.noEmail': 'Guest profile (no email)',
  'guest.card.title': 'You are playing as a guest',
  'guest.card.body':
    'Your games and answers live in this guest profile. If you sign out or clear this browser you cannot get them back. Save your account to keep them.',
  'guest.save.title': 'Save your account',
  'guest.save.intro':
    'Add an email and a password. You keep your games, your partner and your answers.',
  'guest.save.passwordHint':
    'At least 10 characters, with upper and lower case letters, a number and a symbol.',
  'guest.save.submit': 'Save my account',
  'guest.save.busy': 'Saving…',
  'guest.save.done': 'Account saved. Check your email to verify it.',
  'guest.signOut.title': 'Sign out of your guest profile?',
  'guest.signOut.body':
    "If you sign out, this guest profile can't be opened again. Save your account first?",
  'guest.signOut.confirm': 'Sign out anyway',
  'guest.signOut.busy': 'Signing out…',
  'account.delete.guest.warning':
    'Your guest profile, games and answers will be removed for good. There is no password to type.',
  'account.delete.guest.confirm': 'I understand this cannot be undone',
  'security.pin.guestWarning':
    'Five wrong PINs sign you out. A guest profile cannot be opened again after that, so save your account first.',
  'pair.welcome.title': 'Your partner invited you',
  'pair.welcome.body':
    'Play as a guest with just your name, or sign in. Then you pair up in one tap.',
  'landing.cta.createAccount': 'Create an account',
  'landing.free.note':
    'Free for everyone. No account, no card. Just your name.',
  'partner.error.guestEmailUnverified':
    'Pairing needs a saved account on this server. Tap Save my account in Settings, then try again.',
} as const;

export default en;
